var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPerson(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.181,
    height: 21.973,
    viewBox: "0 0 21.181 21.973",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-person-outline",
    "data-name": "Icon material-person-outline",
    d: "M16.591,8.609a2.886,2.886,0,1,1-2.78,2.884,2.833,2.833,0,0,1,2.78-2.884m0,12.36c3.932,0,8.075,2.005,8.075,2.884v1.511H8.515V23.853c0-.879,4.144-2.884,8.075-2.884M16.591,6a5.4,5.4,0,0,0-5.3,5.493,5.4,5.4,0,0,0,5.3,5.493,5.4,5.4,0,0,0,5.3-5.493A5.4,5.4,0,0,0,16.591,6Zm0,12.36C13.056,18.36,6,20.2,6,23.853v4.12H27.181v-4.12C27.181,20.2,20.125,18.36,16.591,18.36Z",
    transform: "translate(-6 -6)",
    fill: "#bcbbbb"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson);
export default __webpack_public_path__ + "static/media/person.a203c94cfc5b51a3a5dd315ef43224f1.svg";
export { ForwardRef as ReactComponent };